import { ThemeOption } from '@helpers/brand';
import { imageUrl } from '@helpers/image';
import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
import React from 'react';
import { CtaCardStyles as S } from './CtaCard.styles';
import { ctaClasses } from '@helpers/trackingClasses';
const CtaCard = ({ content, cta, firstFeatured = false, image, theme = ThemeOption.Orange, title, }) => {
    const defaultImageSize = { width: 348, height: 288 };
    const featuredImageSize = { width: 348, height: 368 };
    const imageSize = firstFeatured ? featuredImageSize : defaultImageSize;
    return (React.createElement(S.Container, { href: cta?.url, target: cta?.target ?? '_self', id: cta?.id, title: title, "data-component-theme": theme, className: ctaClasses.cards },
        React.createElement(S.Image, { alt: image.altText, loading: "lazy", role: image.altText ? undefined : 'presentation', src: imageUrl(image, { ...imageSize }), width: '348', height: firstFeatured ? '368' : '288' }),
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.Title, null, title),
            React.createElement(S.ArrowIcon, null, getSvgFromSystem(SystemIcon.HoverArrowRight)),
            content && React.createElement(S.Content, null, content))));
};
export default CtaCard;
